import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  LiveRegionMode_None_instance = new (LiveRegionMode())('None', 0);
  LiveRegionMode_Polite_instance = new (LiveRegionMode())('Polite', 1);
  LiveRegionMode_Assertive_instance = new (LiveRegionMode())('Assertive', 2);
}
var LiveRegionMode_None_instance;
var LiveRegionMode_Polite_instance;
var LiveRegionMode_Assertive_instance;
var LiveRegionModeClass;
function LiveRegionMode() {
  if (LiveRegionModeClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'LiveRegionMode');
    LiveRegionModeClass = $;
  }
  return LiveRegionModeClass;
}
function LiveRegionMode_None_getInstance() {
  static_init();
  return LiveRegionMode_None_instance;
}
function LiveRegionMode_Assertive_getInstance() {
  static_init();
  return LiveRegionMode_Assertive_instance;
}
//region block: exports
export {
  LiveRegionMode_Assertive_getInstance as LiveRegionMode_Assertive_getInstanceh7tqh38ym97g,
  LiveRegionMode_None_getInstance as LiveRegionMode_None_getInstance2rbbbabo907qu,
};
//endregion

//# sourceMappingURL=LiveRegionMode.mjs.map
